import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import ScrollAnimation from 'react-animate-on-scroll';
import { fetchProducts } from '../../utils/productsApi';

const Product = ({ textAlign, serviceStyle, limit = 3 }) => {
    const [items, setItems] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        let cancelled = false;

        (async () => {
            try {
                const products = await fetchProducts({ limit });
                if (!cancelled) setItems(products);
            } catch (e) {
                console.error('Failed to load homepage products:', e);
                if (!cancelled) setItems([]);
            } finally {
                if (!cancelled) setLoading(false);
            }
        })();

        return () => {
            cancelled = true;
        };
    }, [limit]);

    if (loading) {
        return (
            <div className="row row--15 service-wrapper">
                <div className="col-12 text-center py-4">
                    <img src={`${process.env.PUBLIC_URL}/images/icons/ls.svg`} alt="Loading products" width={32} height={32} />
                </div>
            </div>
        );
    }

    if (!items.length) {
        return null;
    }

    return (
        <div className="row row--15 service-wrapper">
            {items.map((product) => (
                <div className="col-lg-4 col-md-6 col-sm-12 col-12" key={product.id || product.slug}>
                    <ScrollAnimation animateIn="fadeInUp" animateOut="fadeInOut" animateOnce={true}>
                        <div className={`service ${serviceStyle} ${textAlign}`}>
                            <div className="inner">
                                <div className="content">
                                    <h4 className="title">
                                        <Link to={`/products/${product.slug}`}>{product.title}</Link>
                                    </h4>
                                    <p className="description">{product.category || product.shortDescription}</p>
                                </div>
                                <div className="image">
                                    <Link to={`/products/${product.slug}`}>
                                        <img
                                            src={product.thumbnail || product.heroImage}
                                            alt={product.heroImageAlt || product.title}
                                            loading="lazy"
                                            decoding="async"
                                        />
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </ScrollAnimation>
                </div>
            ))}
        </div>
    );
};

export default Product;
